<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-snackbar
        v-model="snackbar"
        xs12
        multi-line
        :timeout="timeout"
        top
        color="orange"
      >
        {{ alertmessage }}
        <v-btn
          color="white"
          text
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </v-snackbar>
      <v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          color="primary"
        />
      </v-col>
    </v-row>
    <sequential-entrance from-top>
      <v-row>
        <v-col
          sm="12"
          md="12"
          lg="12"
        >
          <base-material-card
            v-if="!loading"
            color="primary"
            icon="mdi-map-marker-radius"
            inline
            title="Estate Report"
          >
            <v-row>
              <v-col
                cols="12"
                md="10"
              >
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                />
              </v-col>
              <v-col
                cols="12"
                md="2"
              >
                <download-csv
                  :name="csvfilename()"
                  :data="getlocs"
                >
                  <v-btn color="info">
                    <v-icon
                      color="white"
                      left
                    >
                      mdi-arrow-down
                    </v-icon>CSV
                  </v-btn>
                </download-csv>
              </v-col>
            </v-row>

            <v-data-table
              :headers="locationHeaders"
              :items="getlocs"
              :items-per-page="50"
              sort-by="status"
              item-key="idnum"
              sort-desc
              dense
              :search="search"
            >
              <template v-slot:[`item.notereader`]="{ item }">
                <v-btn
                  fab
                  small
                  color="deep-purple darken-1"
                  :to="'/ReportNotereader/' + item.idnum"
                  dark
                >
                  <v-icon dark>
                    mdi-cash-multiple
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.status`]="{ item }">
                <div
                  v-if="item.status ==='Online'"
                  class="green white--text d-flex justify-center"
                >
                  {{ item.status }}
                </div>
                <div
                  v-if="item.status !=='Online'"
                  class="red white--text d-flex justify-center"
                >
                  {{ item.status }}
                </div>
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'

  export default {

    name: 'Locations',

    data () {
      return {
        expanded: [],
        singleExpand: true,
        search: '',
        loading: false,
        snackbar: false,
        timeout: 5000,
        sites: this.$store.getters.loadedSites,
        profiles: this.$store.getters.loadedSiteProfiles,
        totalcount: 0,
        locations: [],
        locationHeaders: [
          {
            sortable: true,
            text: 'Site',
            value: 'idnum',
            width: 150,
            align: 'left'
          },
          {
            sortable: true,
            text: 'Group',
            value: 'group',
            width: 125,
            align: 'center'
          },
          {
            sortable: false,
            text: 'Safe',
            value: 'safeid',
            align: 'center'
          },
          {
            sortable: true,
            text: 'Notes',
            value: 'notecount',
            align: 'center'
          },
          {
            sortable: true,
            text: 'Capacity',
            value: 'capacity',
            align: 'center'
          },
          {
            sortable: true,
            text: 'Last Ping (UTC)',
            value: 'lastcoms',
            align: 'center'
          },
          {
            sortable: true,
            text: 'Span',
            value: 'ago',
            align: 'center'
          }
        ],
        icons: true,
        centered: true,
        newtab: null,
        activeBtn: 1,
        grow: true,
        alertmessage: ''
      }
    },
    computed: {
      totalSales () {
        return this.sales.reduce((acc, val) => acc + val.salesInM, 0)
      },
      getlocs () {
        this.locations = []
        let today = moment().format('YYYY-MM-DD')

        let eventlist = this.$store.getters.notereaderevents

        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          let name = 'Unknown'
          let group = 'Unknown'
          let capacity = 0
          let loc = this.$store.getters.loadedSites.find(function (site) {
            if (site.idnum === key) {
              return site
            }
          })
          if (loc) {
            name = loc.sitename
            group = loc.group
            capacity = loc.noteCapacity
          }
          if (value.siteunitsprofile) {
            let rejcount = 0
            let notecount = 0
            let safeid = Object.values(value.siteunitsprofile)[0].crypto_idnum
            let notedetails = this.$store.getters.getEstateNoteCount
            notecount = notedetails.find(entry => entry.safeid === safeid)
            let count = 0
            if (notecount) {
              count = notecount.notecount
            }
            console.log('note count data is ', notecount)
            this.$log.debug('looking for events for safe ', safeid)
            let events = eventlist.filter(event => event.crypto_idnum === safeid)
            if (events.length > 0) {
              let todaysevents = events.filter(event => event.day === today)
              if (todaysevents.length > 0) {
                this.$log.debug('today is ', today, ' Todays events ', todaysevents)
                rejcount = todaysevents[0].rejcount
                // this.$log.debug('count is ', todaysevents[0].rejcount)
              }
              //
            }
            this.$log.debug('rej count is ', rejcount)

            let rec = this.$store.getters.getheartbeatvalues.find(element => element.crypto_idnum === safeid)
            let version = 'unkown'
            let lastcoms = 'NA'
            let ago = 'undetermined'
            let servertime = 'NA'
            if (rec && rec.heartbeat && rec.servertime) {
              lastcoms = moment(rec.heartbeat).format('YYYY-MM-DD HH:mm:ss')
              ago = moment(rec.heartbeat).fromNow('HH:mm:ss')
              servertime = moment(rec.servertime).format('YYYY-MM-DD HH:mm:ss')
            }
            if (rec && rec.version) {
              version = rec.version
            }
            let status = 'N/A'
            if (rec) {
              let now = Date.now()
              let mContact = moment(rec.heartbeat)
              let mNow = moment(now)
              let duration = moment.duration(mNow.diff(mContact))
              this.$log.debug('minutes since last contact', duration.asMinutes())
              let MINUTES_CONSIDERED_OFFLINE = 60
              // this.lastheartbeat = moment(rec.heartbeat)
              // this.$log.debug('last heartbeat ', this.lastheartbeat)
              if (duration.asMinutes() <= MINUTES_CONSIDERED_OFFLINE) {
                status = 'Online'
              }
              if (duration.asMinutes() >= MINUTES_CONSIDERED_OFFLINE) { // 60  minutes
                status = 'Offline'
              }
            }
            let shop = {
              idnum: key,
              group: group,
              safeid: safeid.split('-')[1],
              notecount: count,
              capacity: capacity,
              status: status,
              rejcount: rejcount,
              version: version,
              lastcoms: lastcoms,
              servertime: servertime,
              ago: ago
            }
            this.locations.push(shop)
          }
          // this.$log.debug(key,value.siteunitsprofile)
        }
        this.$log.debug('our location map ', this.locations)
        return this.locations
      }
    },
    watch: {
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 1000)
      }
    },
    created () {
      this.loading = true

      this.$store.dispatch('loadunits')
      this.$store.dispatch('loadsiteProfiles')
      this.$store.dispatch('loadUserGroups')
      this.$store.dispatch('loadSiteConfigs')
      this.$store.dispatch('loadnotereaderevents')
      this.$store.dispatch('loadheartbeats')
      this.$store.dispatch('loadsystemdata')
      this.$store.dispatch('loadestatenotecount')
      // let j = Object.keys(loadedprofiles)
      // let units = loadedprofiles[j[0]].siteunitsprofile
    },
    beforeDestroy () {
      // this.$store.dispatch('resetsafetransactions')
    },
    timers: {
      log: { time: 5000, autostart: true, repeat: true }
    },
    methods: {
      log () {
        // this.$store.dispatch('loadheartbeats')
        // this.$store.dispatch('loadsafes')
        // console.log(this.$store.getters.getheartbeatvalues)
      },
      csvfilename () {
        let today = moment().format('YYYY-MM-DD')
        let filename = today + '_statusreport' + '.csv'
        this.$log.debug('file name ', filename)
        return filename
      },
      generateData (count, yrange) {
        var i = 0
        var series = []
        while (i < count) {
          var x = (i + 1).toString()
          var y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min
          series.push({
            x: x,
            y: y
          })
          i++
        }
        return series
      },
      sitestatus (ssid) {
        this.$log.debug('SSID PASSED ', ssid)
        let crypto_idnum = this.$store.getters.loadedSiteProfiles[ssid].siteunitsprofile[0].crypto_idnum
        let rec = this.$store.getters.getheartbeatvalues.find(element => element.crypto_idnum === crypto_idnum)
        let color
        if (rec) {
          let now = Date.now()
          let delta = (now - rec.heartbeat)
          // this.lastheartbeat = moment(rec.heartbeat)
          // this.$log.debug('last heartbeat ', this.lastheartbeat)
          if (delta <= 3600000) {
            color = 'Online'
          }
          if (delta >= 3600000) { // 60  minutes
            color = 'Offline'
          }
          return color
        }
        return 'N/A'
      },
      getsitelabel (ssid) {
        // return ssid
        let label = 'unknown'
        // get list of sites in the system
        this.$store.getters.loadedSites.filter(function (site) {
          if (site.idnum === ssid) {
            label = site.sitename
          }
        })
        return label
        // loop thru, find name
        // return sitename
      },
      complete (index) {
        this.list[index] = !this.list[index]
      }
    }
  }
</script>
